import { CloseCircleFilled, UserOutlined } from "@ant-design/icons";
import logo from "LandingPage/Assets/logo-pure.png";
import { IconPack } from "LandingPage/Config/Icons";
import { resetPassword } from "LandingPage/Services/Login";
import { Input, message } from "antd";
import { useState } from "react";
import styles from "./ResetPassword.module.scss";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [resetPasswordForm, setResetPasswordForm] = useState({
    password: "",
    confirm_password: "",
  });
  const [auth, setAuth] = useState("");

  const handleChangePassword = (e) => {
    setResetPasswordForm({
      ...resetPasswordForm,
      password: e.target.value,
    });
  };
  const handleChangeConfirmPassword = (e) => {
    setResetPasswordForm({
      ...resetPasswordForm,
      confirm_password: e.target.value,
    });
  };
  const handleSubmitPassword = () => {
    if (
      resetPasswordForm.confirm_password !== resetPasswordForm.password ||
      resetPasswordForm.confirm_password.length == 0 ||
      resetPasswordForm.password.length == 0
    ) {
      setAuth(
        "The confirm password does not match or the password entered is empty, please try again."
      );
    } else {
      resetPassword(resetPasswordForm, (res) => {
        if (res.status === "ERROR") {
          setAuth(res.message);
        } else {
          setTimeout(() => {
            message.success(res.detail);
          }, 1000);
          navigate("/explore");
        }
      });
    }
  };
  return (
    <div className={styles["reset-password"]}>
      <div className={styles["nav"]}>
        <img src={logo} alt="academic-online-logo" />
      </div>
      <div className={styles["reset-password-box"]}>
        <div className={styles["box"]}>
          <div className={styles["title"]}>Change Password</div>

          <div className={styles["reset-password-form"]}>
            <div className={styles["form-input"]}>
              <div className={styles["input-title"]}>
                <p>New password</p>
              </div>
              <div className={styles["input"]}>
                <Input.Password
                  onChange={handleChangePassword}
                  placeholder="Enter your password"
                  prefix={<UserOutlined />}
                />
              </div>
            </div>
            <div className={styles["form-input"]}>
              <div className={styles["input-title"]}>
                <p>Confirm password</p>
              </div>
              <div className={styles["input"]}>
                <Input.Password
                  onChange={handleChangeConfirmPassword}
                  placeholder="Confirm your password"
                  prefix={IconPack.keyHole}
                />
              </div>
            </div>
          </div>
          {auth.length > 0 && (
            <div className={styles["reset-password-status"]}>
              <CloseCircleFilled color="red" />
              <p>{auth}</p>
            </div>
          )}
          <div className={styles["reset-password-button"]}>
            <button onClick={handleSubmitPassword}>Submit new password</button>
          </div>
        </div>
      </div>
      <div className={styles["footer"]}>
        <span>© 2022 - 2024 Academic Online. </span>
        <span className={styles["privacy-policy"]}>Privacy Policy</span>
      </div>
    </div>
  );
};

export default ResetPassword;
